let ResolvedAbortController;
let ResolvedCrossFetch = fetch;

if (!process.env.IS_BROWSER) {
    const {
        AbortController: _AbortController,
        abortableFetch,
        // eslint-disable-next-line global-require
    } = require('abortcontroller-polyfill/dist/cjs-ponyfill');
    const { fetch: _fetch } = abortableFetch(fetch);
    ResolvedAbortController = _AbortController;
    ResolvedCrossFetch = _fetch;
} else {
    ResolvedAbortController = window.AbortController;
}

const AbortController = ResolvedAbortController;
const crossFetch = ResolvedCrossFetch;

export { crossFetch, AbortController };
